import { call, put, select, all } from 'redux-saga/effects';
import sendToRelogin from '@gcloud-npm/utils.page.send-to-expired';
import SecureStorage from "@gcloud-npm/utils.secure.local-storage";
// import { upgradeUser as upgradeUserPromise } from '@gerenciatd/next.adabyron.telco.client.upgrade-user';
import { handlingCodes } from '@/constants/constants';
import { handleSagaError } from '@/sagas/index';
import { actions as userActions } from '@/reducers/user';
// TODO: nada de esto se utiliza
import {
  sendButtonTagging,
  sendManagementTagging,
  taggingButtonTypes,
} from '@/utils/taggingUtils';
import { ENV_NAME } from '@gcloud-npm/utils.enums.environment';

const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`

import { actions as InitActions } from '@/reducers/initPage';
import { changePointByComma } from '@/utils/commonUtils';
import { normalizeFusionInfoToStore } from './normalizers/userNormalizer';
import { INCLUDED_R2R_DISCOUNTS_BY_CFI, PROFILES, R2R_V2_306_DISCOUNTS_BY_CFI, USUARIO_PRIMER_R2R_INCLUIDO, USUARIO_SEGUNDO_R2R_INCLUIDO } from '@/constants/get-my-products';
import { normalizeUserBundle } from './normalizers/clientNormalizer';
import { hasMimoClient } from '@/utils/dataHandlers/ClientDataHandler';
const contextStore = (state) => state.main.context;

export function* initializeUser () {
  try {
    const secureStorage = new SecureStorage();
    const persistedInfo = secureStorage.getItem("ts");
    const userInfo = {};
    let renewalRedeemed = false;

    if (persistedInfo) {
      if (persistedInfo.customer) {
        const { customer, userPq } = persistedInfo;
        const redeemedCampaigns = customer?.campaigns?.redeemed;
        if (Array.isArray(customer?.profiles)) {
          userInfo.customerProfiles = customer.profiles.map(profile => profile.id);
          if (userPq?.clt === USUARIO_SEGUNDO_R2R_INCLUIDO || userPq?.clt === USUARIO_PRIMER_R2R_INCLUIDO ) {
            userInfo.isUserNewModelR2R = true;
            const user306Profile = customer.profiles.some(profile => profile.id === PROFILES.R2R_V2);
            if (user306Profile && userPq?.cfi && !userPq?.ecfi) {
              userInfo.userDiscountNewModelR2R = R2R_V2_306_DISCOUNTS_BY_CFI[userPq?.cfi];
            } else if (!user306Profile) {
              userInfo.userDiscountNewModelR2R = INCLUDED_R2R_DISCOUNTS_BY_CFI[userPq?.cfi];
            }
          }
        }
        if (Array.isArray(redeemedCampaigns)) {
          renewalRedeemed = redeemedCampaigns.some((campaign) => campaign.campaignId === "r2r_renovacion_principal");
        }
      }
      if (persistedInfo.userPq) {
        const { clt, cfi, profiles } = persistedInfo.userPq
        userInfo.clientType = clt || null;
        userInfo.categoryFusionInfo = normalizeFusionInfoToStore(cfi) || null;
        userInfo.profiles = profiles || null;
      }
      if (Array.isArray(persistedInfo.userCompatibilities?.r2r?.hiredR2R)) {
        const includedR2RInfo = persistedInfo.userCompatibilities?.r2r?.hiredR2R.find((item) => item.productOfferingType === 'TERMINAL_R2R_INCLUIDO');
        if (includedR2RInfo) {
          userInfo.includedR2RInfo = {
            productOfferingId: includedR2RInfo?.productOfferingId,
            isCancellable: includedR2RInfo?.leasing?.isCancellable && !includedR2RInfo.hasMobileInsurance && !renewalRedeemed,
            cancellationFee: includedR2RInfo?.leasing?.cancellationFee ? `${changePointByComma(includedR2RInfo?.leasing?.cancellationFee)}€` : '',
            productName: includedR2RInfo?.productName,
            endDate: includedR2RInfo?.leasing?.endDate ?
              new Date(includedR2RInfo?.leasing?.endDate).toLocaleDateString() :
              null
          }
        }
      }
      if (persistedInfo.userBundle) {
        userInfo.userBundle = persistedInfo.userBundle;
      }
      const bundleModules = persistedInfo?.userPq?.userPo?.PACK_MODULES?.split("||")
        .map((part) => part.replace(/---/g, "").trim())
        .filter(Boolean);
      if (bundleModules) {
        userInfo.bundleModules = bundleModules;
      }
      if (persistedInfo.userPo) {
        userInfo.userPo = persistedInfo.userPo;
      }
    }
    console.log("USER INFO: ", userInfo)
    // SCOPE LOGIC
    let clientContextData = null;
    yield put(InitActions.setLocation(location));
    const context = yield select(contextStore);

    let moduleGetMyDataTypes = yield call(() =>
      import('@/adabyron/telcol/client/get-my-data-type')
    );
    moduleGetMyDataTypes = moduleGetMyDataTypes.default;

    clientContextData = yield call(moduleGetMyDataTypes, { context });
    if (clientContextData && clientContextData.datos) {
      const { telcoOut, foa, scope, selfEmployed } = clientContextData.datos;
      const isFoa = foa.some((x) => x.toLowerCase() === "hub");
      const pikolin = hasMimoClient({ userInfo });
      const data = {
        telcoOut: { telcoOut },
        foa: isFoa,
        scope: parseInt(scope, 10),
        pikolin,
        userInfo,
        selfEmployed,
      };
      yield put(userActions.successUserInit(data))
    }
  } catch (error) {
    console.error(error);
    if (currentEnv !== ENV_NAME.LOCAL && currentEnv !== ENV_NAME.CODE) {
      console.log('deberia redireccionar....')
      sendToRelogin({})
    }
    // TODO: nada de esto funciona.... o eso creo
    // const reducerFailureAction = userActions.logoutUser();
    // yield handleSagaError(
    //   "initializeUser",
    //   error,
    //   "SONDA_KIND.SEVERAL",
    //   handlingCodes.FATAL,
    //   reducerFailureAction
    // );
  }
}

export function* upgradeUser(params) {
  try {
    sendButtonTagging(taggingButtonTypes.BUTTON, 'upgrade-sesion');
    const { userInfo } = params;
    const data = {
      username: userInfo.username,
      password: userInfo.password,
    };
    const context = yield select(contextStore);
    // const response = yield call(upgradeUserPromise, { data, context });
    const response = '';
    sendManagementTagging('upgrade-sesion', 'upgrade-sesion');
    yield put(userActions.successUpgradeUser(response.datos));
    yield put(userActions.upgradeClear());

    // Prepare upgradeUser to receive callback prop
    if (userInfo.callbackUrl) {
      window.location.replace(userInfo.callbackUrl);
      if (!userInfo.externalLink) {
        window.location.reload();
      }
    } else {
      window.location.replace('#/');
      window.location.reload();
    }
  } catch (error) {
    const reducerFailureAction = userActions.failUpgradeUser();
    yield handleSagaError(
      'upgradeUser',
      error,
      SONDA_KIND.SEVERAL,
      handlingCodes.LOGIN,
      reducerFailureAction
    );
  }
}

const sendToSiteMinderLogOut = (user) => {
  if (user && user.user) {
    window.location.replace(
      'https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/logout.html'
    );
  } else {
    window.location.replace(
      'https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/logout.html?sesionExpirada=1&destino=https://www.movistar.es/mimovistar-cliente/publico/acceso/privado/home'
    );
  }
};

export function* logOutUser(user) {
  try {
    setTimeout(() => {
      sendButtonTagging(taggingButtonTypes.BUTTON, 'cierre-sesion');
      sessionStorage.removeItem('utl');
      sessionStorage.removeItem('nameuser');
      sessionStorage.removeItem('urlhomeprivada');
      sendToSiteMinderLogOut(user);
    }, 1000);
  } catch (error) {
    sessionStorage.removeItem('utl');
    sessionStorage.removeItem('nameuser');
    sessionStorage.removeItem('urlhomeprivada');
    sendToSiteMinderLogOut(user);
  }
}
